export const branches = [
  "",
  "CE",
  "CHE",
  "CSE",
  "ECE",
  "EEE",
  "FT",
  "IT",
  "ME",
  "MEA",
  "MEC",
  "MT",
];
export const semesters = ["", "S1", "S2", "S3", "S4", "S5", "S6", "S7", "S8"];
